import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

/**
 * Dialogs of assistants (projects) that several surfaces open (the sidebar, the conversation
 * menu, right-click, the drawer, ⌘K) and one place renders (`features/workspaces`). A surface
 * asks with `openWorkspaceDialog`; the renderer reads `useWorkspaceDialog`.
 */
export type WorkspaceDialogRequest =
  /** "+ New" under Assistants, ⌘K (D69). */
  { kind: 'new-project' };

interface WorkspaceDialogState {
  request: WorkspaceDialogRequest | null;
}

const dialogs = createStore<WorkspaceDialogState>(() => ({ request: null }));

export function openWorkspaceDialog(request: WorkspaceDialogRequest) {
  dialogs.setState({ request });
}

export function closeWorkspaceDialog() {
  dialogs.setState({ request: null });
}

export function useWorkspaceDialog(): WorkspaceDialogRequest | null {
  return useStore(dialogs, (state) => state.request);
}
